import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {Link} from 'shells/link/link';

export function Unconfigured() {
    return (
        <EmptyStateLarge
            title='Connect your email to Nutshell'
            detailTextBullets={[
                'Create email templates that include automatic, timed follow-up messages',
                'Track open rates and click rates, create personalized email templates, and so much more right in Nutshell',
                'Email your contacts and leads directly from inside Nutshell',
            ]}
            cta={
                <Link
                    // @ts-expect-error
                    as={RoutedLink}
                    variant='button'
                    size='big'
                    to={{
                        hash: '/connect-email/get-started',
                        state: {modal: true},
                    }}
                >
                    Set up email with Nutshell
                </Link>
            }
            icon={
                <img
                    alt=''
                    style={{width: 278}}
                    src='/include/images/email-drip/email-sent-inbox-unconfigured_2x.png'
                />
            }
        />
    );
}
